import React, { useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import { SortValue, Tournament } from '../../../api/responses';
import { useGetTournaments } from '../../../hooks/useGetTournaments';
import PreviewTournament from '../../PreviewTournament';
import SortSelect from '../../SortSelect';
import {
  Title,
  TornamentsContainer,
  TournamentsCount,
  TournamentsHeder,
  TournamentsItemsWrapper,
} from './styles';
import { getTournamentWord } from './utils';

const Tournaments = () => {
  const { ref, inView } = useInView();
  const [page, setPage] = useState(1);
  const [tournamentsData, setTournamentsData] = useState<Tournament[]>([]);
  const [hasMore, setHasMore] = useState(true);
  const [sortValue, setSortValue] = useState<SortValue>('newest');

  const {
    isError,
    data: tournaments,
    isFetching,
    refetch,
  } = useGetTournaments(page, hasMore, sortValue);

  useEffect(() => {
    if (tournaments?.results) {
      const newData = tournaments.results;

      if (page === 1) {
        setTournamentsData(newData);
      } else {
        setTournamentsData((prev) => [...prev, ...newData]);
      }

      const totalLoaded =
        page === 1 ? newData.length : tournamentsData.length + newData.length;
      setHasMore(totalLoaded < tournaments.total_count);
    }
  }, [tournaments, page]);

  useEffect(() => {
    if (inView && hasMore && !isFetching) {
      setPage((prev) => prev + 1);
    }
  }, [inView, hasMore, isFetching]);

  useEffect(() => {
    if (sortValue) {
      refetch();
    }
  }, [sortValue]);

  useEffect(() => {
    setPage(1);
    setTournamentsData([]);
    setHasMore(true);
  }, []);

  if (isError) return <TornamentsContainer>Error</TornamentsContainer>;

  const totalCount = tournaments?.total_count || tournamentsData.length;

  return (
    <TornamentsContainer>
      <Title>Турниры</Title>
      <TournamentsHeder>
        <TournamentsCount>{getTournamentWord(totalCount)}</TournamentsCount>
        <SortSelect sortValue={sortValue} setSortValue={setSortValue} />
      </TournamentsHeder>

      {tournamentsData.length > 0 && (
        <TournamentsItemsWrapper>
          {tournamentsData.map((item) => (
            <PreviewTournament key={item.id} data={item} />
          ))}
          {hasMore && <div ref={ref}>{isFetching ? 'Loading...' : ''}</div>}
        </TournamentsItemsWrapper>
      )}
    </TornamentsContainer>
  );
};

export default Tournaments;
